import { useCallback } from 'react';

/* istanbul ignore next */
var useSetNativeValue = function () {
    //https://github.com/facebook/react/issues/10135
    return useCallback(function (element, value) {
        var _a, _b;
        var valueSetter = (_a = Object.getOwnPropertyDescriptor(element, 'value')) === null || _a === void 0 ? void 0 : _a.set;
        var prototype = Object.getPrototypeOf(element);
        var prototypeValueSetter = (_b = Object.getOwnPropertyDescriptor(prototype, 'value')) === null || _b === void 0 ? void 0 : _b.set;
        if (valueSetter && prototypeValueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter.call(element, value);
        }
        else if (valueSetter) {
            valueSetter.call(element, value);
        }
    }, []);
};

export { useSetNativeValue };
